import { AUTH_ENTER_DELEGATION } from '../../operations/operation-ids.js';
import { MAINTENANCE_DELEGATION_TABLE as DECLARED_SUPPORT_DELEGATION_TABLE } from './maintenance-delegation-descriptors.js';
const ENTER_DELEGATION_ACTION = Object.freeze({
    id: 'action.platformSupportDelegation.enter',
    schemaVersion: 1,
    module: DECLARED_SUPPORT_DELEGATION_TABLE.module,
    feature: DECLARED_SUPPORT_DELEGATION_TABLE.feature,
    telemetryId: 'experience.action.platformSupportDelegation.enter',
    accessibilityLabelKey: 'a11y.action.platformSupportDelegation.enter',
    privacyClassification: 'INTERNAL',
    availability: 'AVAILABLE',
    owner: 'platform-security',
    operationId: AUTH_ENTER_DELEGATION,
    labelKey: 'maintenanceDelegations.actions.enter',
    iconKey: 'security',
    kind: 'localUi',
    intent: 'primary',
    idempotencyRequired: false,
    successBehavior: 'NO_OP',
    errorBehavior: 'SHOW_TOAST_ERROR',
    errorMessageKey: 'common.error.unexpected',
    visibilityCondition: { operator: 'equals', field: 'status', value: 'ACTIVE' },
    order: 10,
    group: 'primary',
});
/** Effective table adds the browser-owned token-rotation action to active rows. */
export const MAINTENANCE_DELEGATION_TABLE = Object.freeze({
    ...DECLARED_SUPPORT_DELEGATION_TABLE,
    rowActions: [
        ENTER_DELEGATION_ACTION,
        ...(DECLARED_SUPPORT_DELEGATION_TABLE.rowActions ?? []),
    ],
});
